import UAParser from "ua-parser-js";
export const BrowserInfo = new UAParser();